import axios from 'axios';
import { auth } from './firebase/firebase';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://us-central1-sail-dev-62f69.cloudfunctions.net/app';

/**
 * Check if email exists in subscription table and return clientId if found
 * @param {string} email - Email address to check
 * @returns {Promise} API response with clientId if found
 */
export const checkEmailSubscription = async (email) => {
    try {
        console.log('🔍 Checking email subscription for:', email);
        
        // Get current user and token
        const currentUser = auth.currentUser;
        if (!currentUser) {
            throw new Error('User not authenticated. Please sign in first.');
        }
        
        const idToken = await currentUser.getIdToken();
        
        const response = await axios.post(`${API_BASE_URL}/subscription/checkEmail`, {
            email: email.toLowerCase().trim()
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`,
            },
            timeout: 10000 // 10 second timeout
        });

        console.log('✅ Email subscription check completed:', response.data);
        return response.data;
        
    } catch (error) {
        console.error('❌ Email subscription check failed:', error);
        
        if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
            throw new Error('TIMEOUT:Request timed out. Please try again.');
        }
        
        // Return null for client not found - this is not an error
        if (error.response?.status === 404) {
            return {
                status: 'Success',
                data: {
                    clientId: null,
                    isExistingClient: false,
                    message: 'No existing subscription found'
                }
            };
        }
        
        throw new Error(`EMAIL_CHECK_ERROR:${error.response?.data?.message || 'Failed to check email subscription'}`);
    }
};

export default { checkEmailSubscription };
